import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService, ITypeRoleBO } from '@mapfre-tech/amap3';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROLES_TREE } from './roles-tree';

@Injectable({
  providedIn: 'root'
})
export class RoleTypeService {

  className = 'RoleTypeService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllRoles(cache = true, cacheKey = "allRoles"): Observable<ITypeRoleBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeRoleBO[]>;
    } else {
      const observable = this.http.get<ITypeRoleBO[]>(environment.base_URL + "/roles-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getRolesTree(): Observable<{ data: { txtTypeRole: string; cdTypeRole: string }; children?: { data: { txtTypeRole: string; cdTypeRole: string } }[] }[]> {
    return of(ROLES_TREE);
  }

  removeById(array: ITypeRoleBO[]) {
    array.forEach((element: ITypeRoleBO) => {
      delete element.idTypeRolePk;
    });
    return array;
  }
}
